import axios from "axios";
import * as fun from "../plugins/common";
import {
  checkIsPermissionsDataLS,
  checkIsPortalDataLS,
  checkIsUserDataLS,
  getPermissionsDataLS,
  getPortalDataLS,
  getUserDataLS,
  removePermissionsDataLS,
  removePortalDataLS,
  removeUserDataLS,
  setPermissionsDataDataLS,
  setPortalDataDataLS,
  setUserDataLS,
  setPermittedActions
} from "../utils/localStorageStore";

const serverURL = fun.getServerURL();
// window.location.host.indexOf("localhost") != -1
//   ? "https://127.0.0.1/5000"
//   : "https://portal.emoversoftware.com";

const saveUserDataFromResponse = (userData, commit) => {
  commit("SET_USER", userData.user);
  commit("SET_IS_HOST", userData.isHost);
  commit("SET_PORTAL_TITLE", userData.portal.company);
  commit("SET_PORTAL_ID", userData.portal.portal_id);
  commit("SET_PERMISSIONS", userData.permissions);
  commit("SET_PERMITED_ACTIONS", userData.permittedActions);
};

export default {
  strict: false,
  namespaced: true,
  state: () => ({
    isAuthenticated: false,
    isCustomerAuthenticated: false,
    loading: false,
    error: null,
    user: {
      user: null,
      isHost: true
    },
    portal: {
      portalTitle: null,
      portalId: null
    },
    permissions: []
  }),
  mutations: {
    SET_AUTHENTICATED(state, isAuth) {
      state.isAuthenticated = isAuth;
    },
    // SET_CUSTOMER_AUTHENTICATED(state, isAuth) {
    //   state.SET_CUSTOMER_AUTHENTICATED = isAuth
    // },
    SET_LOADING(state, isLoading) {
      state.loading = isLoading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_USER(state, user) {
      state.user.user = user;
    },
    SET_IS_HOST(state, isHost) {
      state.user.isHost = isHost;
    },
    SET_PORTAL_TITLE(state, portalTitle) {
      state.portal.portalTitle = portalTitle;
    },
    SET_PORTAL_ID(state, portalId) {
      state.portal.portalId = portalId;
    },
    SET_PORTAL(state, portalObj) {
      state.portal = portalObj;
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions;
    },
    SET_PERMITED_ACTIONS(state, permittedActions) {
      state.permittedActions = permittedActions;
    }
  },
  actions: {
    // CUSTOMERLOGIN({ commit, state, dispatch }, loginData) {
    //   commit("SET_LOADING", true);
    //   axios
    //     .post(serverURL + "/customer_login", loginData, {
    //       withCredentials: true
    //     })
    //     .then(response => {
    //       // console.log("Login data:", response.data);
    //       commit("SET_CUSTOMER_AUTHENTICATED", true);

    //     })
    //     .catch(reason => {
    //       commit("SET_ERROR", reason.response.data);
    //       dispatch("notification/SHOW_ERROR", reason.response.data, {
    //         root: true
    //       });
    //     })
    //     .finally(() => {
    //       commit("SET_LOADING", false);
    //     });
    // },
    LOGIN({ commit, state, dispatch }, loginData) {
      commit("SET_LOADING", true);
      axios
        .post(serverURL + "/login", loginData, {
          withCredentials: true
        })
        .then(response => {
          console.log("Login data:", response.data);
          commit("SET_AUTHENTICATED", true);
          saveUserDataFromResponse(response.data, commit);

          setUserDataLS(response.data.user, response.data.isHost);

          setPortalDataDataLS(response.data.portal);
          setPermissionsDataDataLS(response.data.permissions);
          setPermittedActions(response.data.permittedActions)
          commit("SET_ERROR", null);
        })
        .catch(reason => {
          commit("SET_ERROR", reason.response.data);
          dispatch("notification/SHOW_ERROR", reason.response.data, {
            root: true
          });
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    },
    LOGOUT({ commit, state }) {
      commit("SET_LOADING", true);
      axios
        .post(
          serverURL + "/logout",
          {},
          {
            withCredentials: true
          }
        )
        .then(() => {
          commit("SET_AUTHENTICATED", false);
          commit("SET_USER", null);
          commit("SET_ERROR", null);
          commit("SET_PERMISSIONS", []);
          commit("SET_PERMITED_ACTIONS", null);

          commit("SET_PERMITTED", []);
          removeUserDataLS();
          removePortalDataLS();
          removePermissionsDataLS();
        })
        .catch(reason => {
          commit("SET_ERROR", reason.response.data);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    },
    CHANGE_PORTAL({ commit, state }, portal_id) {
      commit("SET_LOADING", false);
      axios
        .post(
          serverURL + "/change_portal",
          {
            portal_id: portal_id
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          commit("SET_PORTAL_TITLE", response.data.portal.company);
          commit("SET_PORTAL_ID", response.data.portal.portal_id);
          commit("SET_PERMISSIONS", response.data.permissions);
          commit("SET_PERMITED_ACTIONS", response.data.permittedActions);
          setPortalDataDataLS(response.data.portal);
          setPermissionsDataDataLS(response.data.permissions);
          setPermittedActions(response.data.permittedActions)
        })
        .catch(reason => {
          commit("SET_ERROR", reason.response.data);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    },
    CHECK_SESSION({ commit }) {
      if (
        checkIsUserDataLS() &&
        checkIsPortalDataLS() &&
        checkIsPermissionsDataLS()
      ) {
        commit("SET_AUTHENTICATED", true);
        const userData = getUserDataLS();
        commit("SET_USER", userData.user);
        commit("SET_IS_HOST", userData.isHost);
        commit("SET_PORTAL", getPortalDataLS());
        commit("SET_PERMISSIONS", getPermissionsDataLS());
        commit("SET_ERROR", null);
      } else {
        //
        // commit("SET_LOADING", true);
        // axios
        //   .post(
        //     serverURL + "/check_session",
        //     {},
        //     {
        //       withCredentials: true
        //     }
        //   )
        //   .then(response => {
        //     commit("SET_AUTHENTICATED", true);
        //     saveUserDataFromResponse(response.data, commit);
        //     commit("SET_ERROR", null);
        //   })
        //   .finally(() => {
        //     commit("SET_LOADING", false);
        //   });
      }
    }
  },
  getters: {
    permissions: state => {
      return state.permissions;
    },
    user: state => {
      return state.user.user;
    },
    isHost: state => {
      return state.user.isHost;
    },
    portalTitle: state => {
      return state.portal.portalTitle;
    }
  }
};
